module.exports = __webpack_public_path__ + "images/pages/kaitori_bonus_cp_lp/6th/mainvisual-bg-top_1b4a1aa280a2c004812cb8223fcc362c.svg";